import React, { useState, useEffect } from "react";
import { LoginContainer } from "../../common/components/Container";
import smilingWoman from "../../assets/images/smilingwoman.png";
import { StyledTextField } from "../../common/components/TextField/styles";
import alinaAssets from "../../assets/svg/AlinaIcons";
import { useNavigate } from "react-router-dom";
import { login } from "../../api/authApi";
import { getDentistHasChangedPassword } from "../../api/dentistApi";
import { useDispatch } from "react-redux";
import { initUser, setNewDentist } from "../../redux/slices/userSlice";
import { StyledButton } from "../../common/components/Button";
import { useForm } from "react-hook-form";
import Spinner from "../../common/components/Spinner";
import { yupResolver } from "@hookform/resolvers/yup";
import { loginSchema } from "./schema/loginSchema";
import { Stack } from "@mui/system";
import { Alert, Box, Button, Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { IconButton } from "@mui/material";
import { InputAdornment } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Grid } from "@mui/material";
const Login = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    clearErrors,
    watch,
  } = useForm({
    resolver: yupResolver(loginSchema),
    defaultValues: {
      email: "",
      password: "",
    },
  });

  const [email, password] = watch(["email", "password"]);
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token != null) {
      navigate("/cases");
    }
  }, [navigate]);

  useEffect(() => {
    clearErrors();
  }, [clearErrors, email, password]);

  const handleLogin = async (values) => {
    try {
      setLoading(true);
      const response = await login(values);
      const data = response.data.data;
      if (response.data.error === null) {
        localStorage.setItem("token", data.jwt.auth_token);
        const user = {
          id: data.user.id,
          roles: data.roles,
          username: data.user.userName,
          firstname: data.user.firstName,
          lastname: data.user.lastName,
          email: data.user.email,
        };
        console.log(user);
        dispatch(initUser(user));
        if (data.roles.includes("Dentist")) {
          const {
            data: { hasChangedPassword },
          } = await getDentistHasChangedPassword(data.user.id);
          if (!hasChangedPassword) {
            dispatch(setNewDentist(true));
          }
          setLoading(false);
          navigate("/cases");
        } else {
          // not a dentist
          setLoading(false);
          navigate("/cases");
        }
      } else {
        // theres an error
        setLoading(false);
        throw new Error(response.data.error.message);
      }
    } catch (err) {
      console.log(err);
      console.log(err.message);
      if (err.message === "User has not yet been registered.") {
        err.message = "Email or password is incorrect";
      }

      setError("submission", {
        type: "custom",
        message: err.message,
      });
    }
  };

  return (
    <LoginContainer>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          height: "100vh",
          backgroundColor: "#0E0E0E",
        }}
      >
        <div
          style={{
            width: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            paddingLeft: "80px",
          }}
        >
          <form onSubmit={handleSubmit(handleLogin)}>
            <Grid
              container
              rowSpacing={1}
              direction="column"
              alignItems="center"
              justifyContent="center"
              width="100%"
            >
              <Grid item md={12}>
                <div> {alinaAssets.logo("190px", "120px", "white")}</div>
              </Grid>
              <Grid item md={12}>
                {errors.submission && (
                  <Alert style={{ width: "270px" }} severity="error">
                    {errors.submission.message}
                  </Alert>
                )}
              </Grid>

              <Grid item xs={12}>
                <StyledTextField
                  style={{ width: "300px" }}
                  margin="dense"
                  variant="filled"
                  name="email"
                  label="Email"
                  error={errors.email}
                  helperText={errors.email?.message}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  {...register("email")}
                />
              </Grid>
              <Grid item xs={12}>
                <StyledTextField
                  style={{ width: "300px" }}
                  margin="dense"
                  variant="filled"
                  label="Password"
                  name="password"
                  type={!showPassword ? "password" : "text"}
                  error={errors.password}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPassword((show) => !show)}
                          sx={{ width: "36px", height: "32px" }}
                        >
                          {showPassword ? (
                            <FontAwesomeIcon fontSize="medium" icon={faEye} />
                          ) : (
                            <FontAwesomeIcon
                              fontSize="medium"
                              icon={faEyeSlash}
                            />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  helperText={errors.password?.message}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  {...register("password")}
                />
              </Grid>
              <Grid item xs={12}>
                {!loading ? (
                  <StyledButton type="submit" theme="purple" width="300px">
                    Login
                  </StyledButton>
                ) : (
                  <Spinner />
                )}
              </Grid>

              <Grid item xs={12} marginTop="10px">
                <Link
                  as={RouterLink}
                  to="/forgot-password"
                  sx={{
                    fontSize: "13px",
                    fontFamily: "Inter",
                    color: "white",
                  }}
                >
                  Forgot Password?
                </Link>
              </Grid>
            </Grid>
          </form>
        </div>
        <div
          style={{
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundImage: `url(${smilingWoman})`,
            width: "100vw",
            height: "100vh",
          }}
        ></div>
      </div>
    </LoginContainer>
  );
};

export default Login;
